module.exports = __webpack_public_path__ + "img/email.60fd88cd.svg";